import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import { nativeIssueTableEntryPoint } from '@atlassian/jira-native-issue-table/src/ui/entrypoint.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { jqlBuilderWithAiEntryPoint } from '@atlassian/jira-jql-builder-with-ai/src/ui/entrypoint.tsx';

export const globalIssueNavigatorEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-global-issue-navigator-entrypoint" */ './src'),
		{ entryFsSsrLiftImportToModule: true },
	),
	getPreloadProps: (entryPointParams: EntryPointRouteParams) => {
		if (!fg('nin_remove_global_scope_enrolment')) {
			return {};
		}
		const issueKey = entryPointParams?.context?.match?.params?.issueKey;

		return {
			entryPoints: {
				...(!issueKey
					? {
							nativeIssueTableEntryPoint: {
								entryPoint: nativeIssueTableEntryPoint,
								entryPointParams,
							},
							...(fg('jql_builder_basic_ssr_stability_fixes')
								? {
										jqlBuilderWithAiEntryPoint: {
											entryPoint: jqlBuilderWithAiEntryPoint,
											entryPointParams,
										},
									}
								: {}),
						}
					: {}),
			},
		};
	},
});
